import script from "./AddPress.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddPress.vue?vue&type=script&setup=true&lang=ts"

import "./AddPress.vue?vue&type=style&index=0&id=b8e62fb6&scope=true&lang=css"

const __exports__ = script;

export default __exports__